import { FC } from "react";

import TTCCLogoDarkMode from "@/assets/images/ttcc_full_logo_dark_mode.svg?react";
import TTCCLogoLightMode from "@/assets/images/ttcc_full_logo_light_mode.svg?react";
import { useIsDarkMode } from "@/hooks/useIsDarkMode";

type FullLogoPropsType = {
  className?: string;
};

export const FullLogo: FC<FullLogoPropsType> = ({ className }) => {
  const isDarkMode = useIsDarkMode();

  const Logo = isDarkMode ? TTCCLogoDarkMode : TTCCLogoLightMode;

  return <Logo className={className} />;
};
